import { Currency, PlansInfoFragment } from 'src/graphql'

const plansInfo: PlansInfoFragment = {
  plans: [
    {
      id: '1',
      title: 'Basic',
      subtitle: 'FREE',
      isLegacy: false,
      isLimited: true,
      color: 'gray',
      stripeId: 'limited',
      backgroundStartColor: '#87B5C0',
      backgroundEndColor: '#7B9294',
      backgroundImageUrl:
        'https://www.sendoutcards.com/thumbnail/jYMbDOpDYrn-8OOEvn5u89rn4SE=/limitedGray.png',
      price: {
        amount: 0,
        currency: Currency.USD,
        description: '$0.00',
      },
      features: [
        {
          feature: {
            id: '1',
            title: 'Relationship Manager',
            subtitle: '',
            description: '',
          },
          value: 'Limited',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '4',
            title: 'Build your own cards',
            subtitle: '',
            description: '',
          },
          value: '+ $1.00',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '5',
            title: 'Photo Drop Cards',
            subtitle: '',
            description: '',
          },
          value: '+ $1.00',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '6',
            title: 'Storage',
            subtitle: '',
            description: '',
          },
          value: 'Limited',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '11',
            title: 'Group Send Discounts (20+)',
            subtitle: '',
            description: '',
          },
          value: '$2.25 per card',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '12',
            title: 'Postcard',
            subtitle: '',
            description: '',
          },
          value: '$0.91 per card',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '13',
            title: 'Flat Card',
            subtitle: '',
            description: '',
          },
          value: '$2.75 per card',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '14',
            title: 'Two Panel Card',
            subtitle: '',
            description: '',
          },
          value: '$2.75 per card',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '15',
            title: 'Three Panel Card',
            subtitle: '',
            description: '',
          },
          value: '$2.75 per card',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '16',
            title: 'Big Card',
            subtitle: '',
            description: '',
          },
          value: '$4.25 per card',
          included: false,
          featured: false,
          icons: [],
        },
      ],
    },

    {
      id: '6',
      title: 'Card A Day',
      subtitle: 'Relationship Manager System',
      isLegacy: false,
      isLimited: false,
      color: 'purple',
      stripeId: '14547',
      backgroundStartColor: '#BE74DF',
      backgroundEndColor: '#61E2AD',
      backgroundImageUrl:
        'https://www.sendoutcards.com/thumbnail/zvVBZhbJxYpbWk7xpplj6zu5OJI=/basic.png',
      price: {
        amount: 3700,
        currency: Currency.USD,
        description: '$37.00',
      },
      features: [
        {
          feature: {
            id: '1',
            title: 'Relationship Manager',
            subtitle: '',
            description: '',
          },
          value: null,
          included: true,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '2',
            title: 'Heartfelt Card Sends Included',
            subtitle: '',
            description: '',
          },
          value: '30',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '3',
            title: 'Full Card Catalog',
            subtitle: '',
            description: '',
          },
          value: null,
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '4',
            title: 'Build your own cards',
            subtitle: '',
            description: '',
          },
          value: null,
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '5',
            title: 'Photo Drop Cards',
            subtitle: '',
            description: '',
          },
          value: null,
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '6',
            title: 'Storage',
            subtitle: '',
            description: '',
          },
          value: 'Enhanced',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '7',
            title: 'Multi-touch Campaigns',
            subtitle: '',
            description: '',
          },
          value: null,
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '8',
            title: 'Gift Store Discount',
            subtitle: '',
            description: '',
          },
          value: '20% discount',
          included: false,
          featured: false,
          icons: [],
        },

        {
          feature: {
            id: '11',
            title: 'Group Send Discounts (20+)',
            subtitle: '',
            description: '',
          },
          value: '$2.00 per card',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '12',
            title: 'Postcard',
            subtitle: '',
            description: '',
          },
          value: '$0.66 per card',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '13',
            title: 'Flat Card',
            subtitle: '',
            description: '',
          },
          value: '$2.00 per card',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '14',
            title: 'Two Panel Card',
            subtitle: '',
            description: '',
          },
          value: '$2.00 per card',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '15',
            title: 'Three Panel Card',
            subtitle: '',
            description: '',
          },
          value: '$2.00 per card',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '16',
            title: 'Big Card',
            subtitle: '',
            description: '',
          },
          value: '$3.50 per card',
          included: false,
          featured: false,
          icons: [],
        },
      ],
    },
    {
      id: '3',
      title: 'Unlimited',
      subtitle: 'Relationship Manager System',
      isLegacy: false,
      isLimited: false,
      color: 'orange',
      stripeId: '13706',
      backgroundStartColor: '#EB8498',
      backgroundEndColor: '#ECAB84',
      backgroundImageUrl:
        'https://www.sendoutcards.com/thumbnail/-sZ1I38EzdfWgq_kb-ekFpGlkYw=/limited.png',
      price: {
        amount: 9700,
        currency: Currency.USD,
        description: '$97.00',
      },
      features: [
        {
          feature: {
            id: '1',
            title: 'Relationship Manager',
            subtitle: '',
            description: '',
          },
          value: null,
          included: true,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '2',
            title: 'Heartfelt Card Sends Included',
            subtitle: '',
            description: '',
          },
          value: 'Unlimited',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '3',
            title: 'Full Card Catalog',
            subtitle: '',
            description: '',
          },
          value: null,
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '4',
            title: 'Build your own cards',
            subtitle: '',
            description: '',
          },
          value: null,
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '5',
            title: 'Photo Drop Cards',
            subtitle: '',
            description: '',
          },
          value: null,
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '6',
            title: 'Storage',
            subtitle: '',
            description: '',
          },
          value: 'Premium',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '7',
            title: 'Multi-touch Campaigns',
            subtitle: '',
            description: '',
          },
          value: null,
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '8',
            title: 'Gift Store Discount',
            subtitle: '',
            description: '',
          },
          value: '30% discount',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '9',
            title: 'Premier Discounted Shipping',
            subtitle: '',
            description: '',
          },
          value: null,
          included: true,
          featured: false,
          icons: [],
        },

        {
          feature: {
            id: '11',
            title: 'Group Send Discounts (20+)',
            subtitle: '',
            description: '',
          },
          value: '$1.75 per card',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '12',
            title: 'Postcard',
            subtitle: '',
            description: '',
          },
          value: '$0.58 per card',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '13',
            title: 'Flat Card',
            subtitle: '',
            description: '',
          },
          value: '$1.75 per card',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '14',
            title: 'Two Panel Card',
            subtitle: '',
            description: '',
          },
          value: '$1.75 per card',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '15',
            title: 'Three Panel Card',
            subtitle: '',
            description: '',
          },
          value: '$1.75 per card',
          included: false,
          featured: false,
          icons: [],
        },
        {
          feature: {
            id: '16',
            title: 'Big Card',
            subtitle: '',
            description: '',
          },
          value: '$3.25 per card',
          included: false,
          featured: false,
          icons: [],
        },
      ],
    },
    {
      id: '4',
      title: 'Unlimited +100',
      subtitle: 'Relationship Manager System',
      isLegacy: false,
      isLimited: false,
      color: 'red',
      stripeId: '13707',
      backgroundStartColor: '#56DCDE',
      backgroundEndColor: '#61E2AD',
      backgroundImageUrl:
        'https://www.sendoutcards.com/thumbnail/-sZ1I38EzdfWgq_kb-ekFpGlkYw=/limited.png',
      price: {
        amount: 14700,
        currency: Currency.USD,
        description: '$147.00',
      },
      features: [
        {
          feature: {
            id: '1',
            title: 'Relationship Manager',
            subtitle: '',
            description: '',
          },
          value: null,
          included: true,
          featured: false,
          icons: [],
        },
      ],
    },
    {
      id: '39',
      title: 'Unlimited +250',
      subtitle: 'Relationship Manager System',
      isLegacy: false,
      isLimited: false,
      color: 'green',
      stripeId: '14866',
      backgroundStartColor: '#56DCDE',
      backgroundEndColor: '#61E2AD',
      backgroundImageUrl:
        'https://www.sendoutcards.com/thumbnail/-sZ1I38EzdfWgq_kb-ekFpGlkYw=/limited.png',
      price: {
        amount: 24700,
        currency: Currency.USD,
        description: '$247.00',
      },
      features: [
        {
          feature: {
            id: '1',
            title: 'Relationship Manager',
            subtitle: '',
            description: '',
          },
          value: null,
          included: true,
          featured: false,
          icons: [],
        },
      ],
    },
    {
      id: '5',
      title: 'Legacy',
      subtitle: null,
      isLegacy: true,
      isLimited: false,
      color: null,
      stripeId: 'legacy',
      backgroundStartColor: '#333',
      backgroundEndColor: '#333',
      backgroundImageUrl:
        'https://www.sendoutcards.com/thumbnail/kfGiuRU5qzzR9aKJOb2kqDi-Dsc=/5a37630a7db025.5879740415135792745148.png',
      price: {
        amount: 0,
        currency: Currency.USD,
        description: '$0.00',
      },
      features: [],
    },
  ],
  categories: [
    {
      id: '1',
      title: 'Features',
      sortOrder: 4,
      features: [
        {
          id: '1',
          title: 'Relationship Manager',
          subtitle: '',
          description: '',
        },
        {
          id: '2',
          title: 'Heartfelt Card Sends Included',
          subtitle: '',
          description: '',
        },
        {
          id: '3',
          title: 'Full Card Catalog',
          subtitle: '',
          description: '',
        },
        {
          id: '4',
          title: 'Build your own cards',
          subtitle: '',
          description: '',
        },
        {
          id: '5',
          title: 'Photo Drop Cards',
          subtitle: '',
          description: '',
        },
        {
          id: '6',
          title: 'Storage',
          subtitle: '',
          description: '',
        },
        {
          id: '7',
          title: 'Multi-touch Campaigns',
          subtitle: '',
          description: '',
        },
        {
          id: '8',
          title: 'Gift Store Discount',
          subtitle: '',
          description: '',
        },
        {
          id: '9',
          title: 'Premier Discounted Shipping',
          subtitle: '',
          description: '',
        },
      ],
    },
    {
      id: '2',
      title: 'Card Sending',
      sortOrder: 3,
      features: [
        {
          id: '11',
          title: 'Group Send Discounts (20+)',
          subtitle: '',
          description: '',
        },
      ],
    },
    {
      id: '3',
      title: 'Basic Card Pricing',
      sortOrder: 2,
      features: [
        {
          id: '12',
          title: 'Postcard',
          subtitle: '',
          description: '',
        },
        {
          id: '13',
          title: 'Flat Card',
          subtitle: '',
          description: '',
        },
        {
          id: '14',
          title: 'Two Panel Card',
          subtitle: '',
          description: '',
        },
        {
          id: '15',
          title: 'Three Panel Card',
          subtitle: '',
          description: '',
        },
        {
          id: '16',
          title: 'Big Card',
          subtitle: '',
          description: '',
        },
      ],
    },
  ],
  features: [
    {
      id: '1',
      title: 'Relationship Manager',
      subtitle: '',
      description: '',
    },
    {
      id: '2',
      title: 'Heartfelt Card Sends Included',
      subtitle: '',
      description: '',
    },
    {
      id: '3',
      title: 'Full Card Catalog',
      subtitle: '',
      description: '',
    },
    {
      id: '4',
      title: 'Build your own cards',
      subtitle: '',
      description: '',
    },
    {
      id: '5',
      title: 'Photo Drop Cards',
      subtitle: '',
      description: '',
    },
    {
      id: '6',
      title: 'Storage',
      subtitle: '',
      description: '',
    },
    {
      id: '7',
      title: 'Multi-touch Campaigns',
      subtitle: '',
      description: '',
    },
    {
      id: '8',
      title: 'Gift Store Discount',
      subtitle: '',
      description: '',
    },
    {
      id: '9',
      title: 'Premier Discounted Shipping',
      subtitle: '',
      description: '',
    },
    {
      id: '11',
      title: 'Group Send Discounts (20+)',
      subtitle: '',
      description: '',
    },
    {
      id: '12',
      title: 'Postcard',
      subtitle: '',
      description: '',
    },
    {
      id: '13',
      title: 'Flat Card',
      subtitle: '',
      description: '',
    },
    {
      id: '14',
      title: 'Two Panel Card',
      subtitle: '',
      description: '',
    },
    {
      id: '15',
      title: 'Three Panel Card',
      subtitle: '',
      description: '',
    },
    {
      id: '16',
      title: 'Big Card',
      subtitle: '',
      description: '',
    },
  ],
}

export default plansInfo

export const enabledPlans = plansInfo.plans.filter(
  plan => plan.features && plan.features.length > 0,
)
